import React from "react";
import { Table, ButtonToolbar, ButtonGroup, Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ButtonSendActivationMail from "../Button/ButtonSendActivationMail";

const StudentTable = (props) => {
  var students = props.students;

  students = students.sort((a, b) => {
    return a.name > b.name ? 1 : -1;
  });

  if (props.filter && props.filter.length > 0) {
    students = props.students.filter((t) => {
      return (
        t.name.toLowerCase().indexOf(props.filter) !== -1 ||
        t.email.toLowerCase().indexOf(props.filter) !== -1
      );
    });
  }

  let studentCourses = props.studentCourses ? props.studentCourses : [];

  let studentLicenses = [];

  var mappedStudents = students.map((student, id) => {
    studentCourses
      .filter((x) => x.studentId === student.id)
      .forEach((programLicense) => {
        if (studentLicenses.indexOf(programLicense.programLicenseName) === -1)
          studentLicenses.push(programLicense.programLicenseName);
      });
    return (
      <tr key={id}>
        <td>
          <Button
            title={"Gå till elevens sida"}
            className="ps-0"
            color="link"
            onClick={() =>
              props.goToStudentPage(student.id, student.class.name)
            }
            disabled={studentLicenses.length === 0}
          >
            {student.name}
          </Button>
        </td>
        <td>{student.email}</td>
        {props.showClass && <td>{student.class.name}</td>}

        <td>
          <ul className="list-unstyled">
            {studentLicenses.map((license, i) => (
              <li key={i}>{license}</li>
            ))}
          </ul>
        </td>

        <td>
          <ButtonToolbar className="float-end">
            <ButtonGroup size="sm">
              <ButtonSendActivationMail className="float-end" user={student} />
              {/* TODO studenten behöver förväljas i shopen */}
              {/* <Button
                  title={"Köp licens till: " + student.name}
                  color="primary"
                  outline
                  onClick={() => props.goToShop(student.id)}
                >
                  <FontAwesomeIcon icon={"shopping-cart"} />
                </Button> */}
              <Button
                title={"Redigera informationen för " + student.name}
                outline
                color="primary"
                onClick={() => props.toggleEdit(student)}
              >
                <FontAwesomeIcon icon="edit" />
              </Button>
            </ButtonGroup>
          </ButtonToolbar>
        </td>
      </tr>
    );
  });

  return (
    <Table hover responsive striped className="school-table">
      <thead>
        <tr>
          <th>Namn</th>
          <th>E-post</th>
          {props.showClass && <th>Klass</th>}
          <th>Licenser</th>
          <th />
        </tr>
      </thead>
      <tbody>{mappedStudents}</tbody>
    </Table>
  );
};

export default StudentTable;
